import { change, reduxForm, submit } from 'redux-form'
import { connect, useDispatch } from 'react-redux'
import { useEffect, useMemo, useState } from 'react'
import { quickActions } from '../../../../redux/actions/dashboard/quickActionActions'
import ColumnOrderDropdown from '../../../../itrust_common/components/others/ColumnOrderDropdown'
import { withOrder } from '../../../../itrust_common/utils/orderingPreferencesUtils'
import { getQuickActionColumns } from './quickActionsColumns'

const FORM_NAME = 'AddActionDropdown'

function AddActionDropdown(props) {
  const { currentUserRole, saving, whatsAppConfig, showActionsDropdown, orderingPreferences, quickActionColumns } = props
  const dispatch = useDispatch()
  const [showActions, setShowActions] = useState(false)

  const actionsByKey = useMemo(() => {
    const actions = [
      { title: 'New Patient', name: 'patient', icon: 'la-user-plus' },
      { title: 'Appointment', name: 'appointment', icon: 'la-calendar', storeId: true },
      { title: 'Exam', name: 'exam', icon: 'la-stethoscope', storeId: true },
      { title: 'Order', name: 'order', icon: 'la-shopping-cart', storeId: true },
      { title: 'Prescription', name: 'prescription', icon: 'la-file-alt', storeId: true },
      { title: 'Text Message', name: 'send_text_message', icon: 'la-sms', storeId: true },
      { title: 'Phone Call', name: 'make_phone_call', icon: 'la-phone-volume', storeId: true },
      { title: 'Contact Lenses', name: 'add_contact_lens', icon: 'la-glasses', notVisibleTo: ['non_admin'], storeId: true },
      { title: 'Insurances', name: 'add_insurance', icon: 'la-medkit', notVisibleTo: ['admin', 'non_admin'], storeId: true },
      { title: 'Contacts', name: 'add_contact', icon: 'la-user-circle', notVisibleTo: ['non_admin'], storeId: true },
    ]

    if (whatsAppConfig?.visible) {
      actions.splice(6, 0, { title: 'WhatsApp', name: 'whatsapp', icon: 'la-whatsapp', storeId: true })
    }

    return Object.fromEntries(actions.map((action) => [action.name, action]))
  }, [whatsAppConfig?.visible])

  const allColumns = useMemo(() => getQuickActionColumns(quickActionColumns), [quickActionColumns])

  const columns = useMemo(
    () => allColumns.filter((column) => {
      const action = actionsByKey[column.key]
      return action && !action.notVisibleTo?.includes(currentUserRole)
    }),
    [allColumns, actionsByKey, currentUserRole]
  )

  useEffect(() => {
    setShowActions(showActionsDropdown)
  }, [showActionsDropdown])

  const saveColumns = (updatedDisplay) => {
    const displayKeys = new Set(updatedDisplay.map((column) => column.key))
    const hidden = allColumns.filter((column) => !displayKeys.has(column.key))
    const columnsToSave = withOrder([...updatedDisplay, ...hidden])

    dispatch(change(FORM_NAME, 'ordering_preferences', {
      ...orderingPreferences,
      quick_actions: { columns: columnsToSave },
    }))
    setTimeout(() => dispatch(submit(FORM_NAME)), 300)
  }

  const closeDropdown = () => {
    setShowActions(false)
    dispatch(quickActions({ showActionsDropdown: false }))
  }

  return (
    <ColumnOrderDropdown
      id="quickActionsDropdown"
      toggleId="quickActionDropLink"
      show={showActions}
      onClose={closeDropdown}
      columns={columns}
      onColumnsChange={saveColumns}
      saving={saving}
      className="bg-white mr-10 quickActionDropdown shadow border"
      getLabel={(column) => {
        const action = actionsByKey[column.key]
        return (
          <span className="d-flex align-items-center line-height-normal">
            <i className={`la ${action.icon} mr-3`} />
            <span>{action.title}</span>
          </span>
        )
      }}
    />
  )
}

AddActionDropdown = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(AddActionDropdown)

const mapStateToProps = (state) => ({
  orderingPreferences: state.auth.user.ordering_preferences,
  quickActionColumns: state.auth.user.ordering_preferences?.quick_actions?.columns || [],
  currentUserRole: state.auth.user.role,
  saving: state.auth.saving,
  whatsAppConfig: state.organisation.organisation.add_ons_config?.type?.whatsapp,
  showActionsDropdown: state.dashboard.quickAction.showActionsDropdown,
  initialValues: {
    id: state.auth.user.id,
    ordering_preferences: state.auth.user.ordering_preferences,
  },
})

export default connect(mapStateToProps)(AddActionDropdown)
